module.exports = __webpack_public_path__ + "img/gas-station-black-24dp.3f7c6c2f.svg";